import { defineStore } from 'pinia'

interface State {
  viewport: { width: 0; height: 0 }
}

export const useSiteMeasurementStore = defineStore('siteMeasurement', {
  state: (): State => ({
    viewport: { width: 0, height: 0 },
  }),
  getters: {
    vWidth: ({ viewport }) => viewport?.width,
  },
  actions: {
    setViewportSize(payload: { [key: string]: string | number }) {
      this.viewport = {
        ...this.viewport,
        ...payload,
      }
    },
  },
})
